//
//
//
//
//
//

import getfetchImgMx from '@/common/mixin/getfetchImg.js'
export default{
  mixins: [getfetchImgMx],
  props: {
    imgCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      imglist: []
    }
  },
  created() {
    this._getfetchImg(this.imgCode)
  },
  
  methods: {
    implementationFetched([data, res], imgCode) {
      this.$nextTick(() => {
        this.imglist = data.slice(0, 1)
      })
    },
  
    handleClick(links) {
      if (links === '') return
      if (links.indexOf('http') !== -1) {
        window.open(links, '_blank')
      } else {
        if (this.$store.state.showLogin) this.$store.commit('SET_LOGIN_HIDE')
        if (this.$store.state.showRegister) this.$store.commit('SET_REGISTER', false)
        this.$router.replace({ path: links.replace('#', '') })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/img-code-wrap/index.vue